<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="untitled-1">
<div class="calibre1">
</div>
<div class="calibre1">
<p class="normal"><br class="calibre1"/></p>
<p class="chapter-sub">Also by William Florence: </p>
<p class="normal-310-0-override"><span class="no-style-override10">The Max Blake Mystery series:</span></p>
<p class="normal-310-0-override"><span class="no-style-override10"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Raptor’s Ridge</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Misery Ridge</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Faraway Ridge</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Snowfall Ridge</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Emerald Ridge</span></p>
<p class="normal-310-0-override"><span class="no-style-override12"><br class="calibre1"/></span></p>
<p class="heading-1-317-0-override"><span class="no-style-override13">The Max Blake Western series:</span></p>
<p class="heading-1-317-0-override"><span class="no-style-override13"><br class="calibre1"/></span></p>
<p class="heading-2-361-0-override"><span class="no-style-override14">The Killing Trail</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Trail of Revenge</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Trail to Redemption</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Trail to Dead Man’s Gulch</span></p>
<p class="normal-310-0-override"><span class="no-style-override11">Trail from Crooked River</span><span class="no-style-override15"><br class="calibre1"/></span></p>
<p class="calibre3" id="calibre_pb_4"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlsoBy1.vue?8ba0cc7e